import React from "react";
import PropTypes from "prop-types";
import { TopTile } from "@sunwing/wvi-components";
import { RichTextConnector } from "../RichTextConnector";
import { cloudinaryGenURL } from "../../utils/cloudinaryHelpers";

const TopTileConnector = ({ data }) => {
	let theme;

	switch (data.theme) {
		case "Light":
			theme = "light";
			break;
		case "Dark":
		default:
			theme = "dark";
			break;
	}

	let dataImage = data.image?.[0];

	return (
		<TopTile
			image={{
				source: cloudinaryGenURL({
					cloudinaryImage: {
						public_id: dataImage?.public_id,
						baseUrl: dataImage.baseUrl,
						width: 1600,
					},
					maxWidth: 1600,
					baseUrl: dataImage.baseUrl,
					aspectRatio: 1.77777,
				}).data,
				alt: data.image?.[0]?.alt || data.heading,
			}}
			header={data.heading}
			headerAs={data.headingAs}
			button={{
				href: data.link?.url,
				children: data.link?.linkText,
			}}
			theme={theme}>
			{data.content ? <RichTextConnector data={data.content} /> : null}
		</TopTile>
	);
};

TopTileConnector.propTypes = {
	data: PropTypes.shape({
		image: PropTypes.arrayOf(
			PropTypes.shape({
				alt: PropTypes.string,
			})
		),
		heading: PropTypes.string,
		headingAs: PropTypes.string,
		content: PropTypes.object,
		link: PropTypes.shape({
			url: PropTypes.string,
			linkText: PropTypes.string,
		}),
		theme: PropTypes.string,
	}).isRequired,
};

export { TopTileConnector };
